import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Divider,
    Stack,
    Flex,
    Text,
    useMultiStyleConfig,
    useBreakpointValue,
} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import PaymentIcons from '../payment-icons'
import SocialIcons from '../../social-icons'
import CountrySelector from '../../../components/footer/country-selector'
import LegalLinks from '../legal-links'
import useUtils from '../../../custom-hooks/use-utils-helper'
import BrandLogo from '../../icons/shared/logo'
import {useLocation} from 'react-router-dom'

const CopyrightSection = ({data}) => {
    const styles = useMultiStyleConfig('Footer')

    const intl = useIntl()
    const location = useLocation()
    const footerData = data?.footer_bottom_group
    const {isCheckout, isCart, isMaintenance} = useUtils().currentPage(location.pathname)
    const isFooterLite = isCart || isCheckout || isMaintenance

    const copyrightGroup = footerData?.copyright_group
    const copyright = copyrightGroup?.copyright
    const vatNumber = copyrightGroup?.vat_number

    const breakpoint = useBreakpointValue({
        base: null,
        sm: 'sm',
        lg: 'lg',
    })

    return (
        <>
            {breakpoint === 'lg' && (
                <Box
                    w="100%"
                    {...styles.hideOnMobile}
                    display={isFooterLite && 'flex'}
                    justifyContent={'space-between'}
                >
                    {!isFooterLite && <Divider {...styles.dividerRule} />}
                    <Flex {...styles.paymentsLegal} w={isFooterLite && 'fit-content'}>
                        <Stack {...styles.countryPayments}>
                            <Flex {...styles.brandCountry}>
                                <BrandLogo
                                    data-testid="brand-logo"
                                    inverted={true}
                                    {...styles.footerBrand}
                                />
                                {!isFooterLite && (
                                    <Text {...styles.copyright} data-testid="copyright">
                                        {`${copyright} ${vatNumber}`}
                                    </Text>
                                )}
                            </Flex>
                        </Stack>
                        {!isFooterLite && (
                            <Stack {...styles.socialAppPrivacyContainer}>
                                <Stack {...styles.socialAppPrivacy}>
                                    <Flex {...styles.socialApp}>
                                        <SocialIcons
                                            data-testid="social-icons"
                                            icons={footerData?.social_icons}
                                        />
                                    </Flex>
                                </Stack>
                            </Stack>
                        )}
                        {!isFooterLite && (
                            <PaymentIcons
                                data-testid="payment-icons"
                                icons={footerData?.payment_icons}
                            />
                        )}
                    </Flex>
                    {!isFooterLite && <Divider {...styles.dividerRule} />}
                    <Flex
                        {...styles.braunCountryLegal}
                        justifyContent={!isFooterLite ? 'space-between' : 'flex-end'}
                    >
                        {!isFooterLite && <CountrySelector intl={intl} />}
                        <Box>
                            <LegalLinks
                                variant="horizontal"
                                data-testid="legal-links"
                                links={copyrightGroup?.copyright_links}
                            >
                                <Text as="div" id="teconsent" sx={styles.teconsent}></Text>
                            </LegalLinks>
                        </Box>
                    </Flex>
                </Box>
            )}
            {breakpoint === 'sm' && (
                <Box w="100%" {...styles.hideOnDesktop}>
                    <Stack {...styles.mobileStack} {...styles.mobileContainer}>
                        {!isFooterLite && (
                            <SocialIcons
                                data-testid="social-icons"
                                icons={footerData?.social_icons}
                            />
                        )}

                        {!isFooterLite && (
                            <PaymentIcons
                                data-testid="payment-icons"
                                icons={footerData?.payment_icons}
                            />
                        )}

                        {!isFooterLite && <CountrySelector intl={intl} />}

                        <LegalLinks
                            variant="horizontal"
                            data-testid="legal-links"
                            links={copyrightGroup?.copyright_links}
                        >
                            <Text as="div" id="teconsent" sx={styles.teconsent}></Text>
                        </LegalLinks>
                        {!isFooterLite && (
                            <Flex {...styles.brandCopyContainer}>
                                <Flex {...styles.mobileLogoCoutry}>
                                    <BrandLogo
                                        data-testid="brand-logo"
                                        inverted={true}
                                        {...styles.footerBrand}
                                    />
                                </Flex>
                                <Box w="100%" {...styles.copyPositioning}>
                                    <Text data-testid="copyright" {...styles.copyright}>
                                        {`${copyright} ${vatNumber}`}
                                    </Text>
                                </Box>
                            </Flex>
                        )}
                    </Stack>
                </Box>
            )}
        </>
    )
}

CopyrightSection.propTypes = {
    data: PropTypes.shape({
        footer_bottom_group: PropTypes.shape({
            copyright_group: PropTypes.shape({
                copyright: PropTypes.string,
                vat_number: PropTypes.string,
                copyright_links: PropTypes.array,
            }),
            payment_icons: PropTypes.array,
            social_icons: PropTypes.array,
            app_download_icons: PropTypes.array,
        }),
    }),
}

export default CopyrightSection
